/* Native header menus, regional controls and search; no external dependencies. */
(() => {
  const header = document.querySelector('[data-diyion-header]');
  if (!header) return;
  const menus = [...header.querySelectorAll('[data-header-disclosure]')];
  const closeAll = except => menus.forEach(menu => { if (menu !== except) menu.open = false; });
  menus.forEach(menu => {
    menu.addEventListener('toggle', () => {
      if (!menu.open) return;
      closeAll(menu);
      if (menu.classList.contains('dy-header-search')) requestAnimationFrame(() => menu.querySelector('[data-search-input]')?.focus());
    });
  });
  header.addEventListener('click', event => {
    const close = event.target.closest('[data-header-close]');
    if (close) {
      const menu = close.closest('[data-header-disclosure]');
      menu.open = false;
      menu.querySelector(':scope > summary')?.focus({preventScroll: true});
    }
    if (event.target.closest('[data-header-region]')) {
      event.stopPropagation();
      const menu = header.querySelector('.c-language-picker');
      closeAll(menu); menu.open = true;
      requestAnimationFrame(() => menu.querySelector('button[aria-pressed="true"],button')?.focus());
    }
    if (event.target.closest('.dy-mobile-panel a,.dy-mega a')) closeAll();
  });
  header.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const open = menus.find(menu => menu.open);
    if (!open) return;
    event.preventDefault(); closeAll();
    const summary = open.querySelector(':scope > summary');
    if (summary && getComputedStyle(summary).display !== 'none') summary.focus();
    else header.querySelector('.dy-mobile-nav>summary')?.focus();
  });
  document.addEventListener('click', event => { if (!header.contains(event.target)) closeAll(); });
  matchMedia('(min-width:1151px)').addEventListener('change', () => closeAll());
})();
